import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDocument, useDocumentOnce } from 'react-firebase-hooks/firestore';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Card, CardContent, CardMedia, createTheme, CardActionArea, CardActions, TextField, Grid, styled, Paper, Chip, FormControl, InputLabel, Select, InputAdornment, FormGroup, FormControlLabel, FormHelperText, Autocomplete, Slide, Dialog, AppBar, List, Checkbox, Link, Stack, CircularProgress } from "@mui/material";

import isEqual from 'lodash.isequal';

import UserService from '../../services/user.service';
import Iconify from '../../components/iconify';
import { personprops, tocs } from '../../constants';
import BoxingBagDialog from './BoxingBagDialog';

const ListItem = styled('li')(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

UserActions.propTypes = {
    profile: PropTypes.object,
    setProfile: PropTypes.func,
    setEditing: PropTypes.func
  };

export default function UserActions(props) {
    const { profile, setProfile } = props
    const savedProfile = useRef()
    const editingTimer = useRef()
    const [inputsError, setInputsError] = useState({});
    const [showToc, setShowToc] = useState(false);
    const [open, setOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    const [tocsState, setTocsState] = useState(tocs.reduce((p, toc) => ({...p, [toc.name] : false}), {}));


    const handleCloseToc = () => {
      setShowToc(false)
    }

    const handleClickOpen = () => {
      setOpen(true);
    }
    
    useEffect(() => {
      
      console.log(tocsState);
      
    }, [tocsState]);
    const handleTOCChange = (event) => {

      setTocsState({
        ...tocsState,
        [event.target.name]: event.target.checked,
      })

    }
    useEffect(() => {
      if (!savedProfile.current) savedProfile.current = profile
    }, [profile])

    useEffect(() => {
      
      setInputsError(Object.entries(personprops).reduce((p, [name, prop]) => ({...p, [name] : prop.required && (!profile || !profile[name])}), {}))
      
    }, [profile]);


    const noChanges = useMemo(() =>
      // console.log('checking differences');
       isEqual(savedProfile.current, profile) || (Object.entries(inputsError).some(([_, v]) => v))

    , [savedProfile, profile, inputsError])


  const handleSubmit = useCallback(async (event) => {
    console.log('event', event);
    event.preventDefault();

    if (profile && profile.userId) {

        await UserService.updateUserProfile({user: profile}).then(r => {

            // setLog(JSON.stringify(r))
            console.log('r', r);
            if (r) {
                savedProfile.current = profile
            }
        })




      console.log('profile', profile);

    //   if (profile.id) {

    //     // PUT
    //     console.log('profile before putting', profile);
    //     axios.put(`/api/user`, profile).then(function(response){
    //         console.log(response.data);
    //         // setProfile(p => ({ ...p, ...response.data }))
    //         savedProfile.current = profile
    //         setEditing(false)
    //       });

    //   } else {

    //     //  INSERT

    //     const md5 = require('md5');
    //     console.log('profile before posting', profile);
    //     axios.post('/api/user/save', profile).then(function (response) {
    //       console.log(response.data);
    //       if (response.data && response.data.id) {
    //         setProfile(p => ({ ...p, id: response.data.id }))
    //         savedProfile.current = { ...profile, id: response.data.id }
    //       }
    //       setEditing(false)
    //     });
    //   }

}

}, [profile])

    const boxingbagdialog = useMemo(() => {
      return (<BoxingBagDialog  open={open} setOpen={setOpen} handleSubmit={handleSubmit} />)
    }, [open, setOpen])

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const tocsDialog  = (<Dialog
  fullScreen
  open={showToc}
  onClose={handleCloseToc}
  // TransitionComponent={Transition}
>
  <AppBar sx={{ position: 'relative' }}>
    <Toolbar>
      <IconButton
        edge="start"
        color="inherit"
        onClick={handleCloseToc}
        aria-label="close"
      >
        <CloseIcon />
      </IconButton>
      <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
        เงื่อนไขการใช้งานและข้อตกลงเกี่ยวกับการใช้ข้อมูล
      </Typography>
      <Button color="success" variant='contained' onClick={() => {
        setTocsState(tocs.reduce((p, toc) => ({...p, [toc.name] : true}), {}))
        setTimeout(() => {
          setProfile(p => ({...p, tocAccepted: true}))
          handleCloseToc()
        }, 500);
        
      }}>
        ยอมรับทั้งหมด
      </Button>
    </Toolbar>
  </AppBar>
  <FormGroup>
    {tocs.map(toc => (<FormControlLabel 
        key={toc.name}
        required
        control={<Checkbox          
          style={{ pointerEvents: "auto" }}
          disabled={toc.checked}
          checked={toc.checked || tocsState[toc.name]} onChange={handleTOCChange} name={toc.name} />}
        label={<Stack direction={'column'} spacing={0}>
          <p>{toc.label}{'  '}
          <Link
            onClick={(e) => {
              e.preventDefault();
              window.open(toc.uri)
            }}
          >
            อ่าน
          </Link></p>
        {toc.info ? <Typography variant='caption'color={'#555'} >{toc.info}</Typography> : <></>} 

        </Stack>}
        />))}
  </FormGroup>
</Dialog>)

useEffect(() => {
  
  if (!profile) return
  if (profile && !profile.tocAccepted) {
    if (!showToc) setShowToc(true)
  } else {
    setShowToc(false)
  }
  
}, [profile, showToc])


const textfieldsGrid = useMemo(() => {


  const handleProfileEditing = (event, prop) => {
    if (editingTimer.current) clearTimeout(editingTimer.current)
    editingTimer.current = setTimeout(() => {
      setProfile( p => ({...p, [prop] : event.target.value}))      
    }, 100);
    

  }

    console.log('grid updating');
    const { rank, name, surname } = personprops
    return (<Grid container spacing={1}>
      {Object.entries({ rank, name, surname })
        .filter(([key, _ ]) => personprops[key].preferred || personprops[key].required || profile[key])
        .map(([key, prop]) => {
          switch (prop.type) {
            case 'select':
              return (<Grid key={key} item xs={prop.grid || 12}>
              <FormControl fullWidth >
                <InputLabel id={`${key}-select-label`}>{prop.label}</InputLabel>
                <Select
                  fullWidth
                  error={inputsError[key] || (prop.required && (!profile || !profile[key]))}
                  labelId={`${key}-select-label`}
                  id={`${key}-select`}
                  value={(profile && profile[key]) || ''}
                  label={prop.label}
                  onChange={event => {
                    handleProfileEditing(event, key)
                    

                    }
                  }
                >
                  {prop.options.map(r => (<MenuItem key={r.order || r} value={r.name || r}>{r.name || r}</MenuItem>))}
                </Select>
                <FormHelperText>{prop.helperText}</FormHelperText>
              </FormControl>
              </Grid>)

            case 'autocomplete':
              // console.log(profile && profile[key].abbr);
              return (<Grid key={key} item xs={prop.grid || 12}>
                <Autocomplete
                  id="grouped-unit"
                  freeSolo
                  defaultValue={profile && profile[key]}
                  blurOnSelect={"touch"}
                  options={prop.options}
                  groupBy={(option) => option.unittype}
                  getOptionLabel={(option) => option.abbr || ''}
                  sx={{ width: 300 }}
                  renderInput={(params) => <TextField error={inputsError[key] || (prop.required && (!profile || !profile[key]))}
                   {...params} label={prop.inputlabel} />}
                  onChange={(_, newValue) => {
                    handleProfileEditing({ target: { value: newValue } }, key)
                  }}
                  onInputChange={(event, newInputValue) => {
                    
                    handleProfileEditing({ target: { value: {
                      abbr: newInputValue,
                      unittype: 'others'
                        }
                      }
                    }, key)
                  }}

                />
                <FormHelperText>{prop.helperText}</FormHelperText>


              </Grid>)

            case 'multiple':
              return (<Grid key={key} item xs={prop.grid || 12}>


                <TextField
                error={inputsError[key] || (prop.required && (!profile || !profile[key]))}
                id={key}
                helperText={prop.helperText}
                label={prop.label} variant="outlined"
            // onChange={event => handleProfileEditing(event, key)}
            onKeyDown={(ev) => {
              // console.log(`Pressed keyCode ${ev.key}`);
              if (ev.key === 'Enter') {
                // Do code here
                ev.preventDefault();
                setProfile(p => ({...p, [key]: p[key] ? [...p[key], ev.target.value] : [ev.target.value]}))
                ev.target.value = ""
              }
            }}
              />

            <Paper
              sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                listStyle: 'none',
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {profile && profile[key] && (Array.isArray(profile[key]) ? profile[key] : [profile[key]]).map((data) => {
                console.log('profile changed');
                return (
                  <ListItem key={data}>
                    <Chip
                      label={data }
                      onDelete={() => {
                        setProfile(p => {
                            console.log('setting profile');
                          return {...p,
                            [key] : (Array.isArray(p[key]) ?  p[key] : [p[key]]).filter(i => i !== data)
                          }
                        })
                      }}
                    />
                  </ListItem>
                );
              })}
            </Paper>

            </Grid>)

            case 'switch':
              return (<Grid key={key} item xs={prop.grid || 12}>

              <FormGroup>
                  <FormControlLabel control={<Checkbox defaultChecked />} label={prop.label} />
              </FormGroup>
            </Grid>)

            default:
              return (<Grid key={key} item xs={12} sm={prop.grid || 12} md={4} lg={3}>
                <TextField
                helperText={prop.helperText}
                // defaultValue={prop.default || ''}
                error={inputsError[key] || (prop.required && (!profile || !profile[key]))}
             fullWidth id={key} type={prop.type} label={prop.label} variant="outlined" defaultValue={(profile && profile[key]) || ''}

              InputProps={ prop.suffix ? {
                endAdornment: <InputAdornment position="end">{prop.suffix}</InputAdornment>,
              } : {}}
              onChange={event => {
                handleProfileEditing(event, key)

                setInputsError(e => ({...e, [key]: prop.required && event.target.value === ""}))
              }}
                />
              </Grid>)

          }
        })}

  </Grid>)
  }, [inputsError, profile, setProfile])


    if (saving) return <Box sx={{ mt: 6}}><CircularProgress /></Box>
    return (<><Card sx={{ maxWidth: {xs: '100%', sm: '75%'}, md: '50%' }}>
      <CardActionArea>
        {profile && profile.pictureUrl && <CardMedia
          component="img"
          height="80%"
          image={profile.pictureUrl}
          alt={profile.displayName}
        />}
        <CardContent>
        <Typography gutterBottom variant="h5" component="div">
        {profile && profile.displayName}
        {/* {JSON.stringify(savedProfile.current)} */}
          </Typography>
        <Box sx={{ flexGrow: 1 }}>

          {/* MARK:- PROFILE EDITING */}

          {textfieldsGrid}
      


        {/* {JSON.stringify(inputsError)} */}
        </Box>
        </CardContent>
      </CardActionArea>
      <CardActions>
        {profile && profile.name ? <Button size="small" color="primary" variant='contained' onClick={() => handleClickOpen()} >
          ลงชื่อใช้กระสอบทราย
          {/* {liff.isInClient() ? 'เช็ครอบจอง' : 'ลงทะเบียนคนต่อไป'} */}
        </Button> : <></>}                  
        <Button size="small" color="error" onClick={() => {
          // setProfile(savedProfile.current)
          setSaving(true)
          // setEditing(false)
        }}>
          ยกเลิก
        </Button>
      </CardActions>
    </Card>
    {tocsDialog}
    {boxingbagdialog}
    </>)
}